import { Callout, Pre, Spinner, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";

export default function DB(props) {
  const [db, setDB] = useState();
  const [version, setVersion] = useState();

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/db?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (db) => setDB(db)
    );
    authenticatedGetFetch(
      "/ow/dc/version?" + new URLSearchParams({ srv: props.srv }),
      (version) => setVersion(version),
      null,
      null,
      () => setVersion({ name: "?", version: "?" })
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout icon="database" title={<Trans>current database status</Trans>}>
      {db ? (
        <div>
          <p>
            <Tag large="true">{db?.transactions?.total}</Tag>{" "}
            <Trans>transactions stored</Trans> ({" "}
            <Tag>{db?.transactions?.hashed}</Tag> <Trans>anonymised</Trans> )
          </p>

          <p>
            <Tag large="true">{db?.detections?.total}</Tag>{" "}
            <Trans>detections stored</Trans> ({" "}
            <Tag>{db?.detections?.hashed}</Tag> <Trans>anonymised</Trans> )
          </p>

          <p>
            <Tag large="true">{db?.detections?.images}</Tag>{" "}
            <Trans>images stored</Trans>
            {/* ( <Tag>{"TODO"}</Tag>{" "}
            <Trans>masquées</Trans> ) */}
          </p>
          <Pre>
            server version: {version?.name}_{version?.version}
          </Pre>
          <Pre>
            database size: {db?.db_size}
          </Pre>
        </div>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
